/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {IconService as ɵa} from './lib/icon.service';